import type { JSX } from "solid-js";

type BadgeTone = "good" | "warning" | "danger" | "neutral" | "info";

interface StatusBadgeProps {
  label: string;
  tone?: BadgeTone;
  dot?: boolean;
}

export function StatusBadge(props: StatusBadgeProps): JSX.Element {
  return (
    <span class={`status-badge status-badge--${props.tone ?? "neutral"}`}>
      {props.dot === false ? null : <span class="status-badge__dot" aria-hidden="true" />}
      {props.label}
    </span>
  );
}
